import classnames from 'classnames';
import type { ComponentProps, ReactElement, ReactNode } from 'react';
import styles from './Tabs.module.scss';
import { Button } from 'common/components/Button';

export type TabButtonProps = {
  active?: boolean;
  children: ReactNode;
} & ComponentProps<typeof Button>;

export function TabButton(props: TabButtonProps): ReactElement {
  const { active, ...otherProps } = props;

  return (
    <Button
      {...otherProps}
      className={classnames({
        [styles.activeTab]: !!active,
        [styles.inactiveTab]: !active
      })}
    />
  );
}
